export default {

    signature: 'qv-ref',

    handle(node, scope) {

        if (node.nodeType !== Node.ELEMENT_NODE) {
            return null
        }

        const referenceName = node.getAttribute(this.signature)

        if (!referenceName) {
            return
        }

        scope.$refs[ referenceName ] = node

        return () => {

            if (scope.$refs[ referenceName ] === node) {
                delete scope.$refs[ referenceName ]
            }

        }

    },

}
